import { useMutation } from 'react-query';
import { useDispatch, useSelector } from 'react-redux';
import axios from 'axios';
import { useParams } from 'react-router-dom';
import { changeIsSummaryOpened, downloadPdf, downloadPdfComplete } from '../model/configuratorSlice';
import { ClientName, EndPoints } from '../model/constants';
import { AccessTokenAuth } from '../auth/AccessTokenAuth';
import { FeatureSelectionUtility } from '../utilities/FeatureSelectionUtility';
import IsNullOrUndefined from '../utils/ObjectUtils';


export default function DownloadPdfService() {
    const {
        settings, categories, currentUnit, token,
    } = useSelector(state => state.configurator);
    const { promotionSlug } = useParams();
    const dispatch = useDispatch();

    return useMutation(['downloadPdfQuery'], () => {
        const featureSelection = FeatureSelectionUtility.CreateFeatureSelectionString(categories);
        let downloadPdfUrl = `${EndPoints.PublicDownloadPdf}/${promotionSlug}/code/${featureSelection}/download-pdf`;
        let data = {};

        if (!IsNullOrUndefined(currentUnit)) {
          // eslint-disable-next-line max-len
          downloadPdfUrl = `${EndPoints.DownloadPdf}/${promotionSlug}/unit/${currentUnit.id}/code/${featureSelection}/download-pdf`;
          data = {
            token,
          };
        }

        const fileName = `${ClientName}_${settings.name}_borrador.pdf`;
        const config = {
            responseType: 'blob',
        };

        dispatch(downloadPdf());
        dispatch(changeIsSummaryOpened(false));

        axios
            .post(downloadPdfUrl, data, config)
            .then((response) => {
                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', fileName);
                document.body.appendChild(link);
                link.click();
                dispatch(downloadPdfComplete());
            })
            .catch((error) => {
                console.log(error);
                dispatch(downloadPdfComplete());
            });
    });
}
